import { CognitoIdentityProviderClient, ListUsersInGroupCommand, AdminCreateUserCommand, AdminDisableUserCommand, 
  AdminDeleteUserCommand, AdminEnableUserCommand, ListGroupsCommand, AdminAddUserToGroupCommand,
  CreateGroupCommand} from "@aws-sdk/client-cognito-identity-provider";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { format } from "date-fns";
const reg = 'ap-southeast-2'
const options ={
  // Required. The unique identifier for the identity against which credentials
  // will be issued.
  identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY,
  // Optional. The ARN of the role to be assumed when multiple roles were received in the token
  // from the identity provider.
  clientConfig: { region: reg },
}
const config = {
  region: reg,
  credentials: fromCognitoIdentityPool (options),
}

//client can be shared
const client = new CognitoIdentityProviderClient(config)

const store = {
    namespaced: true,
    state: {
      users: [],
      groups:[]
    },
    mutations: {
      users (state, users) {
        state.users = users
      },
      groups(state,groups){
        state.groups = groups
      }
    },
    actions: {
      async fetchCognitoUsersByGroup(context,groupName){
        const params ={
            UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
            GroupName:groupName
          }

        const command = new ListUsersInGroupCommand(params)
        
        try {
          const data = await client.send(command);
          let users = []
          data.Users.forEach(
            (user) =>{
              user.UserCreateDate = format(
                new Date(user.UserCreateDate),
                "dd/MM/yy HH:mm"
              )
              user.UserLastModifiedDate = format(
                new Date(user.UserLastModifiedDate),
                "dd/MM/yy HH:mm"
              )
              let attributesObj = user.Attributes.reduce((obj, cur) => {return {...obj, [cur.Name]: cur.Value }}, {})
              delete user.Attributes
              users.push({...attributesObj,...user}) //merge custom attributes into user object
            
            }
              
          )
          context.commit('users', [...users])
          // process data.
        } catch (error) {
          console.log(error)
          // error handling.
        } finally {
          // finally.
        }
  
      },

      //create an user in oc terminal user pool
      async createUser(context, userObj){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userObj.username,
          email_verified: true,
          DesiredDeliveryMediums: [
            'EMAIL'
          ],
          UserAttributes: [
            { Name: "email", Value: userObj.email },
            { Name: "email_verified", Value: "True" },
            { Name: "custom:venue", Value: userObj.venue },
            { Name: "custom:admin", Value: userObj.admin.toString() }
          ],
          ForceAliasCreation: false,
          MessageAction: "SUPPRESS",
        }

        const command = new AdminCreateUserCommand(params)
        try {
          await client.send(command);
          await context.dispatch('EnsureGroupExisting',userObj.venue)
          await context.dispatch('AddUserToGroup',{userName:userObj.username,groupName:userObj.venue})
          await context.dispatch('ResendConfirmationEmail',userObj.username)
        }
        catch(e){
          alert(e)
        }

      },

      //check if a group exist in cognito or not, if not existing, then create one
      async EnsureGroupExisting(context,groupName){
        context.dispatch('fetchGroups')
        if (context.getters.getGroups.findIndex(g=>g.GroupName == groupName) < 0 ){
          const params = {
            UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
            GroupName:groupName
          }
          
          const command = new CreateGroupCommand(params)
          try {
            await client.send(command);
          }
          catch(e){
            alert(e)
          }
        }
        
      },

      //add an user into a group
      async AddUserToGroup(context,{userName,groupName}){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userName,
          GroupName:groupName
        }

      
        const command = new AdminAddUserToGroupCommand(params)
        try {
          await client.send(command);
        }
        catch(e){
          alert(e)
        }
      },

      //resend the confirmation email for an existing user
      async ResendConfirmationEmail(context,userName){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userName,
          MessageAction: "RESEND",
        }
      
        const command = new AdminCreateUserCommand(params)
        try {
          await client.send(command);
        }
        catch(e){
          alert(e)
        }
      },

      //get all the user groups
      async fetchGroups(context){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
        }
      
       
        const client = new CognitoIdentityProviderClient(config)
        const command = new ListGroupsCommand(params)
        try {
          const data = await client.send(command);
          context.commit('groups',data.Groups)
        }
        catch(e){
          alert(e)
        }
      },

      //disable the user from the user pool
      async DisableUser(context,userName){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userName,
        }
      
        const command = new AdminDisableUserCommand(params)
        try {
          await client.send(command);
        }
        catch(e){
          alert(e)
        }
      },

      //enable a disabled user
      async EnableUser(context,userName){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userName,
        }
      
        const command = new AdminEnableUserCommand(params)
        try {
          await client.send(command);
        }
        catch(e){
          console.log(e)
        }
      },

      //delete a disabled user from the pool
      async DeleteUser(context,userName){
        const params = {
          UserPoolId:process.env.VUE_APP_COGNITO_POOL_ID,
          Username: userName,
        }
      
        const command = new AdminDeleteUserCommand(params)
        try {
          await client.send(command);
        }
        catch(e){
          alert(e)
        }
      }
    },
    getters: {
      getUsers: (state) =>{
        return state.users
      },
      getGroups: (state) =>{
        return state.groups
      }
    },
      
}

export default store